    <div class="d-md-flex justify-content-between">
      <p class="fw-bold fs-16">{{headTitle}}</p>
      <app-dropdown  [list]="listDropDown" (selected)="selectedfromDropDown($event)"></app-dropdown>
    </div>